import { GET_FLOOR_DATA } from "../type";
import { supabase } from "../../supabase/supabaseClient";

export const getfloorData = (floorNum) => async (dispatch) => {
  try {
    const res = await supabase
      .from("floor")
      .select()
      .eq("floorNumber", floorNum)
      .order("unitNumber", { ascending: true });

    dispatch({
      type: GET_FLOOR_DATA,
      payload: res.data || [],
    });
  } catch (error) {
    console.log("Error fetching floor", error);
    dispatch({
      type: GET_FLOOR_DATA,
      payload: [],
    });
  }
};

export const getfloorDatabyStaus =
  ({ floorNum, status }) =>
  async (dispatch) => {
    try {
      let query = supabase.from("floor").select("*");

      if (floorNum) {
        query = query.eq("floorNumber", floorNum);
      }

      if (status && status !== "all") {
        query = query.eq("Status", status === "Available");
      }

      const { data, error } = await query;

      if (error) {
        console.error("Error fetching floor data:", error);
        dispatch({
          type: GET_FLOOR_DATA,
          payload: [],
        });
        return;
      }

      dispatch({
        type: GET_FLOOR_DATA,
        payload: data || [],
      });
    } catch (error) {
      console.error("Error in getfloorDatabyStaus:", error);
      dispatch({
        type: GET_FLOOR_DATA,
        payload: [],
      });
    }
  };

export const add = (unitData) => async (dispatch) => {
  try {
    const res = await supabase
      .from("floor")
      .insert([
        {
          floorNumber: unitData.floorNum,
          unitNumber: unitData.unitNum,
          SQFT: unitData.SQFT,
          terraceSQFT: unitData.terraceSQFT || 0,
          Status: unitData.Status,
        },
      ])
      .select()
      .eq("floorNumber", unitData.floorNum)
      .order("unitNumber", { ascending: true });

    if (res.data.length > 0) {
      dispatch({
        type: GET_FLOOR_DATA,
        payload: res.data,
      });
      console.log("floorData", res.data);
    }
  } catch (error) {
    console.log("Error adding floor data", error);
  }
};

export const update = (unitData) => async (dispatch) => {
  try {
    const res = await supabase
      .from("floor")
      .update({
        SQFT: unitData.SQFT,
        terraceSQFT: unitData.terraceSQFT || 0,
        Status: unitData.Status,
      })
      .eq("floorNumber", unitData.floorNum)
      .eq("unitNumber", unitData.unitNum)
      .select("*")
      .order("unitNumber", { ascending: true });

    if (res.data.length > 0) {
      dispatch({
        type: GET_FLOOR_DATA,
        payload: res.data,
      });
      console.log("floorData", res.data);
    }
  } catch (error) {
    console.log("Error updating floor data", error);
  }
};

export const deleteUnit = (unitData) => async (dispatch) => {
  try {
    await supabase
      .from("floor")
      .delete()
      .eq("floorNumber", unitData.floorNum)
      .eq("unitNumber", unitData.unitNum);
  } catch (error) {
    console.log("Error deleting unit", error);
  }
};
